(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["FLASHSALES"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sectionId = '{{ section.id }}';

  var hEl = document.getElementById('cd-h-' + sectionId);
  var mEl = document.getElementById('cd-m-' + sectionId);
  var sEl = document.getElementById('cd-s-' + sectionId);

  var totalSeconds = (23 * 3600) + (19 * 60) + 50;

  function pad(n) { return String(n).padStart(2, '0'); }

  function tick() {
    if (totalSeconds <= 0) {
      clearInterval(timer);
      return;
    }
    var h = Math.floor(totalSeconds / 3600);
    var m = Math.floor((totalSeconds % 3600) / 60);
    var s = totalSeconds % 60;
    if (hEl) hEl.textContent = pad(h);
    if (mEl) mEl.textContent = pad(m);
    if (sEl) sEl.textContent = pad(s);
    totalSeconds--;
  }

  tick();
  var timer = setInterval(tick, 1000);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["FLLASHSALES"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sectionId = '{{ section.id }}';

  var hEl = document.getElementById('cd-h-' + sectionId);
  var mEl = document.getElementById('cd-m-' + sectionId);
  var sEl = document.getElementById('cd-s-' + sectionId);

  var totalSeconds = (23 * 3600) + (19 * 60) + 50;

  function pad(n) { return String(n).padStart(2, '0'); }

  function tick() {
    if (totalSeconds <= 0) {
      clearInterval(timer);
      return;
    }
    var h = Math.floor(totalSeconds / 3600);
    var m = Math.floor((totalSeconds % 3600) / 60);
    var s = totalSeconds % 60;
    if (hEl) hEl.textContent = pad(h);
    if (mEl) mEl.textContent = pad(m);
    if (sEl) sEl.textContent = pad(s);
    totalSeconds--;
  }

  tick();
  var timer = setInterval(tick, 1000);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flash-sale"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sectionId = '{{ section.id }}';
  var endDateStr = '{{ section.settings.sale_end_date }}';
  var endDate = endDateStr ? new Date(endDateStr) : new Date(Date.now() + 6 * 60 * 60 * 1000);

  var hEl = document.getElementById('cd-h-' + sectionId);
  var mEl = document.getElementById('cd-m-' + sectionId);
  var sEl = document.getElementById('cd-s-' + sectionId);

  function pad(n) { return String(n).padStart(2, '0'); }

  function tick() {
    var diff = Math.max(0, Math.floor((endDate - Date.now()) / 1000));
    var h = Math.floor(diff / 3600);
    var m = Math.floor((diff % 3600) / 60);
    var s = diff % 60;
    if (hEl) hEl.textContent = pad(h);
    if (mEl) mEl.textContent = pad(m);
    if (sEl) sEl.textContent = pad(s);
    if (diff <= 0) clearInterval(timer);
  }

  tick();
  var timer = setInterval(tick, 1000);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
